import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { setupAxios } from 'utils/auth-helper'
import { AuthProvider } from 'context/auth'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-tooltip/dist/react-tooltip.css'
import 'cropperjs/dist/cropper.css'
import 'react-date-picker/dist/DatePicker.css'
import 'react-datetime-picker/dist/DateTimePicker.css'
import 'react-time-picker/dist/TimePicker.css'
import 'react-clock/dist/Clock.css'
import 'react-calendar/dist/Calendar.css'
import './index.css'
import { AgencyProvider } from 'context/agency'
import { LocationProvider } from 'context/location'
import ErrorBoundary from 'component/ErrorBoundary'
import { reportClientError } from 'utils/report-error'

// Catches crashes React's own error boundary can't (module-level throws
// during a lazy chunk's initial evaluation, uncaught promise rejections) —
// without this, a device where the bundle fails to even start rendering
// just shows a blank page with zero server-side visibility into why.
window.addEventListener('error', (event) => {
  reportClientError(event.error || event.message)
})
window.addEventListener('unhandledrejection', (event) => {
  reportClientError(event.reason)
})

setupAxios()
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <LocationProvider>
          <AgencyProvider>
            <App />
          </AgencyProvider>
        </LocationProvider>
      </AuthProvider>
      <ToastContainer />
    </BrowserRouter>
  </ErrorBoundary>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
